<template>
  <button
    type="button"
    :class="
      tableCell({
        numeric,
        class: [
          'group/sort text-inherit inline-flex max-w-full items-center gap-1 rounded-sm hover:text-obsidian-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-obsidian-300 focus-visible:ring-offset-1',
          numeric ? 'w-full justify-end' : '',
        ],
      })
    "
    :aria-sort="ariaSort"
    @click="handleClick"
  >
    <span class="truncate"><slot /></span>
    <component
      :is="icon"
      class="size-3.5 shrink-0 transition-opacity"
      :class="
        isActive ? 'text-obsidian-800' : 'text-obsidian-400 opacity-40 group-hover/sort:opacity-100'
      "
    />
  </button>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon } from 'lucide-vue-next';
import { tableCell } from '@carvia/theme/lib/cva/grid';
import { sortableTableKey } from './sortable-table';

const props = defineProps<{
  column: string;
  numeric?: boolean;
}>();

const sort = inject(sortableTableKey);
if (!sort) {
  throw new Error('SortableTableHeaderCell must be used inside SortableTableHeader');
}

const isActive = computed(() => sort.sortColumn.value === props.column);

const ariaSort = computed(() => {
  if (!isActive.value) return 'none';
  return sort.sortDirection.value === 'asc' ? 'ascending' : 'descending';
});

const icon = computed(() => {
  if (!isActive.value) return ArrowUpDownIcon;
  return sort.sortDirection.value === 'asc' ? ArrowUpIcon : ArrowDownIcon;
});

const handleClick = () => {
  if (sort.sortColumn.value !== props.column) {
    sort.sortColumn.value = props.column;
    sort.sortDirection.value = props.numeric ? 'desc' : 'asc';
    return;
  }
  sort.sortDirection.value = sort.sortDirection.value === 'asc' ? 'desc' : 'asc';
};
</script>
